// ============================================================
// 運営あての通知メール
// EmailJSの認証情報は運営が「メール送信設定」画面から登録する。
// ============================================================
import emailjs from "@emailjs/browser";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

/**
 * 新規登録やお問い合わせがあったことを運営へメールで知らせる。
 *
 * 設定が未入力のときは何もしない。またメールを送れなくても、
 * 登録や問い合わせそのものは成立させたいので例外は投げない。
 *
 * @param {object} params テンプレートに渡す値
 *   event_type   何が起きたか（「会社の新規登録」など）
 *   company_name 会社名と会社コード
 *   user_name    氏名
 *   user_email   メールアドレス
 *   detail       本文に載せる詳細
 */
export async function notifyOperator(params) {
  try {
    const snap = await getDoc(doc(db, "notifySettings", "system"));
    const sys = snap.exists() ? snap.data() : {};
    if (!sys.emailjsServiceId || !sys.emailjsOperatorTemplateId || !sys.emailjsPublicKey) return;

    await emailjs.send(
      sys.emailjsServiceId,
      sys.emailjsOperatorTemplateId,
      // 未指定の変数があるとテンプレート側で空欄になるため、既定値を入れておく
      { event_type: "", company_name: "", user_name: "", user_email: "", detail: "", ...params },
      sys.emailjsPublicKey
    );
  } catch (err) {
    console.warn("運営への通知メールを送れませんでした:", err);
  }
}
